import { Pipe, PipeTransform, inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { firstValueFrom } from 'rxjs';
import { BdPermissionsGroupsService } from './groups.service';

@Pipe({
  name: 'group',
  standalone: true,
})
export class BdPermissionGroupIdPipe implements PipeTransform {
  private _permissionService = inject(BdPermissionsGroupsService);


  transform(value: string): Promise<string | undefined> {
    return firstValueFrom(
      this._permissionService.byId(value).pipe(map((group) => group?.name)),
    );
  }
}
